export const data = {
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/34e9c92772d4-tooliconmessage.jpg',
  },
  title: 'Can you share a short description of what happened?',
  placeholderText:
    'Eg. I received a text from someone pretending to be Barclays. The text said that a new payee was being added to my account and asked me to click through to a website to stop the payee from being added.',
}
